/* HTML EXAMPLE:
  <div data-controller="glance-columns"
       data-glance-columns-urls-value='{"today":"/admin/categories/x/glance_columns/today", ...}'>
    <table>
      ...
      <td id="glance_visits_today_value" data-glance-window="today">...</td>
      <td id="glance_visits_today_compare" data-glance-window="today">...</td>
      ...
    </table>
  </div>

  Fetches each window's column as a Turbo Stream (updates targeting the td
  ids) so cheap windows (Today) render without waiting on expensive ones.
*/

import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { urls: Object };

  connect() {
    Object.entries(this.urlsValue).forEach(([window, url]) =>
      this.loadColumn(window, url),
    );
  }

  loadColumn(window, url) {
    fetch(url, { headers: { Accept: "text/vnd.turbo-stream.html" } })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then((html) => Turbo.renderStreamMessage(html))
      .catch((error) => {
        console.error(`Error loading the ${window} glance column:`, error);
        this.renderError(window);
      });
  }

  // Never inject a failed response's HTML — error pages carry global CSS.
  renderError(window) {
    this.element
      .querySelectorAll(`td[data-glance-window="${window}"]`)
      .forEach((cell) => {
        cell.innerHTML =
          '<div class="h-5 flex items-center justify-end">' +
          '<span class="text-red-600" title="Failed to load">&mdash;</span></div>';
      });
  }
}
